// eslint-disable-next-line import/no-anonymous-default-export
export default {
    // error messages
    MFE00001 : "Please select %s!",
    MFE00002 : "Please fill %s!",
    MFE00003 : "%s must be at most %s characters long!",
    MFE00004 : "%s must be number!",
    MFE00005 : "%s must be greater than or equal to %s!",
    MFE00006 : "%s must be less than or equal to %s!",
    MFE00007 : "Please fill %s or %s!",
    MFE00008 : "Please choose %s!",
    MFE00009 : "An error occurred while %s!",
    MFE00010 : "Invalid %s!",
    MFE00011 : "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character!",
    MFE00012 : "Passwords must match!",
    MFE00013 : "%s must be at least %s characters long!",
    MFE00014 : "Please Select one or more rows to Delete",
    MFE00015 : "Please select only one Category!",
    MFE00016 : "%s must be at least %s characters long!",
    MFE00017 :  "Please select at least one contract!",
    MFE00018 :  "Please select only Discount data!",
    MFE00019 :  "Please select only Penalty Waive data!",
    MFE00020 :  "Application has been locked by another IHCO!",
   
    // success messages
    MFS00001 : "%s created successfully",
    MFS00002 : "%s deleted successfully",
    MFS00003 : "%s updated successfully",
    MFS00004 : "Copy %s successfully",
    MFS00005 : "Data Import Successful",
    MFS00006 : "Status Change Success",
    MFS00007 : "Create Success",
    MFS00008 : "Update Success",
    MFS00009 : "Success",
    MFS00010 : "Reassign Success",
    MFS00011 : "Delete Success",
    MFS00012 : "Remove Success",
    MFS00013 : "Cancel Success",
    MFS00014 : "Locked Success",
    MFS00015 : "UnLocked Success",
    MFS00016 : "Assigned Success",


    // confirmation messages
    MFC00001 : "Are you sure you want to delete this data?",
    MFC00002 : "Are you sure you want to delete selected rows?",
    MFC00003 : "Are you sure you want to save this information?",
    MFC00004 : "Are you sure you want to create new Stamp Duty Payment?",
    MFC00005 : "Are you sure you want to settle this information?",
    MFC00006 : "Are you sure you want to approved this information?",
    MFC00007 : "Are you sure you want to reject this information?",
    MFC00008 : "Are you sure you want to post this information?",
    MFC00009 : "Are you sure you want to submit this information?",
    MFC00010 : "Are you sure you want to create write off preparation batch?",
    MFC00011 : "Are you sure you want to inactive this data?",
    MFC00012 : "Are you sure you want to create new Disbursement Payment?",
    MFC00013 : "Are you sure you want to create new Insurance Payment?",
}